module.exports = __webpack_public_path__ + "img/neuvector.06c4d0f5.svg";